import type { IconName } from 'lucide-react/dynamic'

export const DEFAULT_PROJECT_ICON: IconName = 'plus'
